export const extractNonEmptyAccount = <T extends object | null | undefined>(
  account: T
): Exclude<T, null | undefined> | undefined => {
  if (!account) return undefined;

  return Object.keys(account as object).length
    ? (account as Exclude<T, null | undefined>)
    : undefined;
};
